export default {
  en: {
    test: {
      foo: "ENGLISH"
    }
  }
}
